import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';
import { I18nProvider } from './i18n/I18nProvider';

import './styles/bootstrap-custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/tokens.css';
import './styles/animations.css';
import './App.css';
import './boost.css';
import './index.css';

// Self-hosted Fonts - Critical weights only to optimize FCP/TTI
import '@fontsource/bricolage-grotesque/500.css';
import '@fontsource/bricolage-grotesque/700.css';
import '@fontsource/cairo/400.css';
import '@fontsource/cairo/700.css';
import '@fontsource/noto-kufi-arabic/700.css';
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';

if (typeof window !== 'undefined' && (window as any).trustedTypes && (window as any).trustedTypes.createPolicy) {
  if (!(window as any).trustedTypes.defaultPolicy) {
    (window as any).trustedTypes.createPolicy('default', {
      createHTML: (string: string) => string,
      createScript: (string: string) => string,
      createScriptURL: (string: string) => string,
    });
  }
}

const rootElement = document.getElementById('root') as HTMLElement;
// Guard SSR Document Access
const initialLang = typeof document !== 'undefined' && document.documentElement.lang === 'en' ? 'en' : 'ar';


const app = (
  <StrictMode>
    <I18nProvider initialLang={initialLang}>
      <App />
    </I18nProvider>
  </StrictMode>
);

if (import.meta.env.PROD) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
